'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SomeHash$() {
  this.cc0 = null;
  this.cc1 = false;
  this.cbY = null;
  this.cbZ = false;
}
export { $c_Lpresto_types$SomeHash$ as $c_Lpresto_types$SomeHash$ };
$p = $c_Lpresto_types$SomeHash$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SomeHash$;
/** @constructor */
function $h_Lpresto_types$SomeHash$() {
}
export { $h_Lpresto_types$SomeHash$ as $h_Lpresto_types$SomeHash$ };
$h_Lpresto_types$SomeHash$.prototype = $p;
$p.a2E = (function() {
  if ((!this.cc1)) {
    this.cc0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.cc1 = true;
  }
  return this.cc0;
});
$p.a2A = (function() {
  if ((!this.cbZ)) {
    this.cbY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.cbZ = true;
  }
  return this.cbY;
});
var $d_Lpresto_types$SomeHash$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SomeHash$, "presto.types$SomeHash$", ({
  a26: 1
}));
export { $d_Lpresto_types$SomeHash$ as $d_Lpresto_types$SomeHash$ };
var $n_Lpresto_types$SomeHash$;
function $m_Lpresto_types$SomeHash$() {
  if ((!$n_Lpresto_types$SomeHash$)) {
    $n_Lpresto_types$SomeHash$ = new $c_Lpresto_types$SomeHash$();
  }
  return $n_Lpresto_types$SomeHash$;
}
export { $m_Lpresto_types$SomeHash$ as $m_Lpresto_types$SomeHash$ };
//# sourceMappingURL=presto.types$-Some-Hash$.js.map
